import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { RefreshTokenAction, LogoutAction } from '@tsin-core/actions/auth.action';
import { AuthState } from '@tsin-core/states/auth.state';
import { catchError, switchMap, throwError } from 'rxjs';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);
  const token = store.selectSnapshot<string | null>(AuthState.getToken);
  const refreshToken = store.selectSnapshot<string | null>(AuthState.getRefreshToken);

  if (token && token.length > 0) {
    if (!req.url.includes('/api/auth/refresh')) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
  }

  return next(req).pipe(
    catchError((error: any) => {
      // Handle 401 or 403 errors by attempting token refresh
      if ((error.status === 401 || error.status === 403) &&
          refreshToken &&
          !req.url.includes('/api/auth/refresh') &&
          !req.url.includes('/api/auth/login')) {

        return store.dispatch(new RefreshTokenAction({ refreshToken })).pipe(
          catchError((refreshError) => {
            // Refresh token failed - logout and redirect to login
            console.error('Token refresh failed, logging out user');
            store.dispatch(new LogoutAction());
            router.navigate(['/auth/login'], {
              queryParams: { sessionExpired: true }
            });
            return throwError(() => refreshError);
          }),
          switchMap((state: any) => {
            // Get new token from state after refresh
            const newToken = store.selectSnapshot<string | null>(AuthState.getToken);
            if (newToken) {
              const clonedReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next(clonedReq);
            }
            // New token not found after refresh - logout
            console.error('New token not found after refresh, logging out');
            store.dispatch(new LogoutAction());
            router.navigate(['/auth/login'], {
              queryParams: { sessionExpired: true }
            });
            return throwError(() => error);
          })
        );
      }

      // For other errors, just propagate
      return throwError(() => error);
    })
  );
};
